import React from 'react';
import styled from 'styled-components';

interface Props {
  label: string;
}

function Date({ label }: Props) {
  return <Component id="post-date">{label}</Component>;
}

export default Date;

const Component = styled.p`
  display: block;

  margin-top: 20px;

  font-weight: 700;
  font-size: 14px;
  line-height: 140%;
  color: ${(props) => props.theme.black100};
  opacity: 0.5;

  @media (min-width: 1400px) {
    margin-top: 0;

    font-size: 18px;
  }
`;
